<ng-container [ngSwitch]="type$ | async">
  <math-bad-request *ngSwitchCase="enums.ErrorType.BadRequest"></math-bad-request>
  <math-forbidden *ngSwitchCase="enums.ErrorType.Forbidden"></math-forbidden>
  <math-not-found *ngSwitchCase="enums.ErrorType.NotFound"></math-not-found>
  <math-server-error *ngSwitchCase="enums.ErrorType.ServerError"></math-server-error>
</ng-container>
